// Copyright (c) Quang Phan. All rights reserved. Licensed under the MIT license.

import { vitePluginBeautify } from './plugin';

/**
 * tailwind plugin for building triangle with border attributes
 *
 * @packageDocumentation
 */

export = vitePluginBeautify;
